import { ReactElement } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import { BASE_NUGGET_IMAGE_MAX_HEIGHT } from './BaseNugget';

type NuggetEventProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        date: string;
        previewImage?: string;
      }
    | { type: 'LARGE' };
}>;

export const NuggetEvent = ({ variant }: NuggetEventProps): ReactElement => {
  if (variant.type === 'SMALL') {
    return (
      <Box sx={containerSx}>
        {variant.previewImage ? (
          <Box component="img" src={variant.previewImage} alt="Event Preview" sx={coverImageSx} />
        ) : (
          <Box sx={fallbackBackgroundSx} />
        )}
      </Box>
    );
  }

  return <></>;
};

const containerSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

const coverImageSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  aspectRatio: '16/9',
  maxHeight: BASE_NUGGET_IMAGE_MAX_HEIGHT,
  objectFit: 'cover',
  borderRadius: backrs.radius['radius-2xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});

const fallbackBackgroundSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  aspectRatio: '16/9',
  maxHeight: BASE_NUGGET_IMAGE_MAX_HEIGHT,
  backgroundColor: backrs.colors['Colors/Background/bg-brand-primary'],
  borderRadius: backrs.radius['radius-2xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});
